/**
 * Captura la pantalla actual como JPEG comprimido (< 4.5 MB) y devuelve solo el
 * base64 (sin el prefijo data:), listo para mandar al agente de soporte.
 * Devuelve null si la captura falla (no debe romper el flujo).
 */
export async function captureScreenshotBase64(): Promise<string | null> {
  try {
    const { default: html2canvas } = await import('html2canvas');
    const canvas = await html2canvas(document.body, { logging: false, useCORS: true, scale: 1 });
    const LIMIT = 4.5 * 1024 * 1024;
    let dataUrl = '';
    for (const q of [0.7, 0.5, 0.35, 0.25]) {
      dataUrl = canvas.toDataURL('image/jpeg', q);
      if (dataUrl.length * 0.75 < LIMIT) break;
    }
    return dataUrl.split(',', 2)[1] ?? null;
  } catch {
    return null;
  }
}
